import * as styles from "./CollapsibleTrigger.css";

import type { JSX } from "react";

import { Collapsible as BaseCollapsible } from "@base-ui/react/collapsible";
import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";

import { useCollapsibleContext } from "./Collapsible.context";
import type { CollapsibleTriggerProps } from "./Collapsible.types";

export function CollapsibleTrigger({
  className,
  children,
  ...props
}: CollapsibleTriggerProps): JSX.Element {
  const { size, variant } = useCollapsibleContext();

  return (
    <BaseCollapsible.Trigger
      data-slot="collapsible-trigger"
      className={className}
      render={
        <Button variant={variant} size={size} disableRipple>
          <Icon name="ChevronRight" size="sm" className={styles.icon} />
          {children}
        </Button>
      }
      {...props}
    />
  );
}
